interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '名称やロゴを掲載しなければ、施設で自由に実施できますか？',
    answer: '名称やロゴを掲載していない場合でも、介護・医療・音楽等の指定役務として「パタカラ」を用いたサービスやプログラムを実施・提供する行為には、商標権の効力が及びます。施設サービスとして実施する場合は、事前に公式施設ライセンスをご取得いただくか、当社へご相談ください。',
  },
  {
    question: '利用者に「パタカラ」を発声させる場合もライセンスが必要ですか？',
    answer: '介護・医療施設等が提供する口腔機能向上サービスやプログラムとして、利用者に「パタカラ」を発声させる場合は、公式施設ライセンスの対象となります。家庭内で個人的に発声する場合など、事業または施設サービスとして提供されない私的な利用を制限するものではありません。',
  },
  {
    question: 'カラオケを使って実施する場合も対象になりますか？',
    answer: '介護・医療施設等が、カラオケ機器やカラオケ音源を使用して「パタカラ」を実施・提供する場合も、公式施設ライセンスの対象となります。',
  },
  {
    question: 'すでにWEBサイトや資料で使用しています。どうすればよいですか？',
    answer: '現在の利用方法が分かるWEBサイトのURL、パンフレット、施設内資料等を添えてお問い合わせください。内容を確認し、公式施設ライセンスの適用または必要な対応をご案内します。',
  },
  {
    question: '公式ロゴを使用できますか？',
    answer: '公式ロゴの使用には、公式施設ライセンスまたは当社の個別許諾が必要です。ロゴの色、形、文字の配置等を変更せず、当社が提供する正式なロゴデータをご使用ください。',
  },
  {
    question: '自治体や官公庁にも月額費用がかかりますか？',
    answer: '地域の健康増進、介護予防、福祉活動など、非営利の公的事業における利用は、原則として有料ライセンスの対象外です。ご利用前に利用目的、実施内容および使用媒体をご連絡いただき、内容確認後に無料の使用許可証を発行します。',
  },
  {
    question: '許諾団体から受け取った資料を別の施設で使用できますか？',
    answer: '許諾は、当社が確認した自治体・団体、利用目的、実施内容、使用媒体および使用範囲に限り有効です。許諾団体から資料を受け取った場合でも、別の施設や団体がそのまま「パタカラ®」を利用できるものではありません。利用を希望する施設・団体から、当社へ直接ご相談ください。',
  },
];

interface FAQSectionProps {
  openFaq: number | null;
  toggleFaq: (index: number) => void;
}

export default function FAQSection({ openFaq, toggleFaq }: FAQSectionProps) {
  return (
    <section id="faq" className="py-16 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-slate-800 text-center mb-12">
          よくあるご質問
        </h2>

        <div className="space-y-4">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full px-6 py-5 flex items-start justify-between gap-4 text-left hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <div className="flex items-start gap-4 flex-1">
                  <div className="w-8 h-8 rounded-full bg-gray-400 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-white text-sm font-bold">Q</span>
                  </div>
                  <p className="text-base font-bold text-slate-800 leading-relaxed pt-1">
                    {faq.question}
                  </p>
                </div>
                <i className={`ri-arrow-down-s-line text-2xl text-gray-400 transition-transform duration-300 flex-shrink-0 ${openFaq === index ? 'rotate-180' : ''}`}></i>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${openFaq === index ? 'max-h-[500px]' : 'max-h-0'}`}
              >
                <div className="px-6 pb-5">
                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 rounded-full bg-orange-500 flex items-center justify-center flex-shrink-0">
                      <span className="text-white text-sm font-bold">A</span>
                    </div>
                    <p className="text-base text-gray-700 leading-relaxed pt-1">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}